import { AssignmentOutlined } from "@mui/icons-material";
import { Button, Tooltip } from "@mui/material";
import React, { useState } from "react";
import LoanBorrowerAssignFilesModal from "../../../../screens/LoanDrilldownScreen/tabs/LoanDrilldownBorrowersTab/LoanDrilldownBorrowersTabRedesign/LoanBorrowerAssignFilesModal";

const AssignLoanFilesButton = ({
  borrower,
  variant = "outlined",
  color = "gray",
  size = "medium",
  sx,
  children,
}) => {
  const [show, setShow] = useState(false);
  return (
    <>
      <Tooltip title="Assign Files to Borrower">
        <Button
          onClick={() => setShow(true)}
          // maxWidth="unset"
          color={color}
          variant={variant}
          size={size}
          //   maxWidth="165px"
          // iconSize={18}
          sx={{
            // ml: 2,
            flexGrow: 1,
            // fontStyle: "italic",
            // fontWeight: 400,
          }}
          text={"Assign Existing File"}
          startIcon={<AssignmentOutlined sx={{ mx: 0.5 }} className="thin" />}
        >
          {children || "Assign Files"}
        </Button>
      </Tooltip>
      <LoanBorrowerAssignFilesModal
        show={show}
        borrowerId={borrower?._id}
        onClose={() => setShow(false)}
      />
    </>
  );
};

export default AssignLoanFilesButton;
